/** @flow */
import { startRequest, finishRequest } from "@store/utils";
import {
  GetReportingFocusListsDepartmentDefaultReports,
  GetReportingFocusListsDepartmentDefaultReportsSuccess,
  GetReportingFocusListsDepartmentDefaultReportsError,
  GetReportingFocusListsDepartmentMyReports,
  GetReportingFocusListsDepartmentMyReportsSuccess,
  GetReportingFocusListsDepartmentMyReportsError,
  GetFocusListsDepartmentReportSchemaSuccess,
  GetFocusListsDepartmentReportSchemaError,
  SetFocusListsDepartmentReportToSave,
  ReSetFocusListsDepartmentReportToSave,
} from "@modules/reporting/constants/actions";
import type { Reports } from "./types";
import { cloneObject } from "@utils/object";

export const initialState = {
  requestsInProgress: 0,
  error: null,
  defaultReports: [],
  myReports: [],
  schema: null,
  reportToSave: null,
};

export const setLoading = (state: Reports) => () => startRequest(state);

export const onGetReportingFocusListsDepartmentDefaultReportsSuccess = (state: Reports) => ({
  payload,
}: Object) => ({
  ...finishRequest(state),
  error: null,
  defaultReports: payload,
});

const onGetReportingFocusListsDepartmentDefaultReportsError = (state: Reports) => ({
  payload,
}: Object) => ({
  ...finishRequest(state),
  error: payload.error,
});

export const onGetReportingFocusListsDepartmentMyReportsSuccess = (state: Reports) => ({
  payload,
}: Object) => ({
  ...state,
  // ...finishRequest(state),
  error: null,
  myReports: payload,
});

const onGetReportingFocusListsDepartmentMyReportsError = (state: Reports) => ({
  payload,
}: Object) => ({
  ...state,
  // ...finishRequest(state),
  error: payload.error,
});

export const onGetFocusListsDepartmentReportSchemaSuccess = (state: Reports) => ({
  payload,
}: Object) => ({
  ...state,
  error: null,
  schema: payload,
});

export const onGetFocusListsDepartmentReportSchemaError = (state: Reports) => ({
  payload,
}: Object) => ({
  ...state,
  error: payload.error,
});

export const onSetFocusListsDepartmentReportToSave = (state: Reports) => ({ payload }: Object) => ({
  ...state,
  reportToSave: payload,
});
export const onReSetFocusListsDepartmentReportToSave = (state: Reports) => ({
  payload,
}: Object) => ({
  ...state,
  reportToSave: null,
});

export const onGetReportingFocusListsDepartmentMyReports = (state: Reports) => ({
  payload,
}: Object) => ({
  ...state,
  myReports: [],
});

export default (state: Reports = initialState, action: Object): Reports => {
  const act = {
    [GetReportingFocusListsDepartmentDefaultReports]: setLoading,
    [GetReportingFocusListsDepartmentDefaultReportsSuccess]: onGetReportingFocusListsDepartmentDefaultReportsSuccess,
    [GetReportingFocusListsDepartmentDefaultReportsError]: onGetReportingFocusListsDepartmentDefaultReportsError,
    // [GetReportingFocusListsDepartmentMyReports]: setLoading,
    [GetReportingFocusListsDepartmentMyReports]: onGetReportingFocusListsDepartmentMyReports,
    [GetReportingFocusListsDepartmentMyReportsSuccess]: onGetReportingFocusListsDepartmentMyReportsSuccess,
    [GetReportingFocusListsDepartmentMyReportsError]: onGetReportingFocusListsDepartmentMyReportsError,
    [GetFocusListsDepartmentReportSchemaSuccess]: onGetFocusListsDepartmentReportSchemaSuccess,
    [GetFocusListsDepartmentReportSchemaError]: onGetFocusListsDepartmentReportSchemaError,
    [SetFocusListsDepartmentReportToSave]: onSetFocusListsDepartmentReportToSave,
    [ReSetFocusListsDepartmentReportToSave]: onReSetFocusListsDepartmentReportToSave,
  };

  if (action && action.type && act && act[action.type]) {
    return act[action.type](cloneObject(state))(action);
  }
  return state;
};
